import { ApolloClient, InMemoryCache, createHttpLink, split, } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { WebSocketLink } from "@apollo/client/link/ws";
import { getMainDefinition } from "@apollo/client/utilities";
export default function getApolloClient({ token, uri, connectToDevTools, name, }) {
    // TODO: refactor env variables
    const wsUri = uri.replace(/http/, "ws");
    const httpLink = createHttpLink({ uri });
    const wsLink = new WebSocketLink({
        lazy: true,
        uri: wsUri,
        options: {
            reconnect: true,
            connectionParams: {
                headers: {
                    authorization: token ? `Bearer ${token}` : "",
                },
            },
        },
    });
    const authLink = setContext((_, { headers }) => {
        if (!token) {
            return { headers };
        }
        return {
            headers: {
                ...headers,
                authorization: `Bearer ${token}`,
            },
        };
    });
    const splitLink = split(({ query }) => {
        const definition = getMainDefinition(query);
        return (definition.kind === "OperationDefinition" &&
            definition.operation === "subscription");
    }, wsLink, authLink.concat(httpLink));
    return new ApolloClient({
        link: splitLink,
        cache: new InMemoryCache(),
        connectToDevTools,
        name,
    });
}
//# sourceMappingURL=getApolloClient.js.map